import { unblockDayApi as generatedUnblockDayApi } from '../generated/slots/unblockDay';

const unblockDayApi = generatedUnblockDayApi.enhanceEndpoints({
  endpoints: {
    unblockDay: {
      invalidatesTags: (result) => [
        { type: 'Schedule' as const },
        { type: 'ScheduleAroundToday' as const },
        ...(result?.updated.map(({ date }) => ({ id: date, type: 'Slots' as const })) ?? []),
      ],
    },
  },
});

export const { useUnblockDayMutation } = unblockDayApi;
